import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';

import { HeaderDetalhamento } from './HeaderDetalhemento';
import { DadosMotorista } from './DadosMotorista';
import { DadosConsultas } from './DadosConsultas';

export function DetalhamentoSolicitacao({ solicitacao, loading = false }) {
  const [dataConsultas, seDataConsultas] = useState(null);

  useEffect(() => {
    seDataConsultas({ ...solicitacao });
  }, [solicitacao]);

  return (
    <Row>
      <Col span={24}>
        <HeaderDetalhamento solicitacao={solicitacao} loading={loading} />
      </Col>
      <Col span={24}>
        <DadosMotorista data={solicitacao} loading={loading} />
      </Col>
      <Col span={24}>
        <DadosConsultas data={dataConsultas} loading={loading} />
      </Col>
    </Row>
  );
}
